import {GenericService, ResultType} from '@/shared/xhttp';
import {Option} from '@/models';

export class OptionService extends GenericService<Option> {

	public getAll(): Promise<ResultType<Option>> {
		return this.getC('', 99999999, 0, 'id');
	}

}